import { useEffect, useState } from 'react';

/** Same breakpoint as the `@media (max-width: 760px)` rules in the stylesheets. */
export const PHONE_QUERY = '(max-width: 760px)';

export function isPhone(): boolean {
  return typeof window !== 'undefined' && window.matchMedia(PHONE_QUERY).matches;
}

/** True on phone-width screens; re-renders when the window crosses the breakpoint (rotation, resize). */
export function useIsPhone(): boolean {
  const [phone, setPhone] = useState(isPhone);
  useEffect(() => {
    const mq = window.matchMedia(PHONE_QUERY);
    const onChange = () => setPhone(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return phone;
}
